export const ArrowDown = ({ className }: { className: string }) => (
	<svg
		className={className}
		viewBox="0 0 16 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.75 2.91666V11.0833"
			// stroke="#00AAA9"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.2709 7L7.75008 11.0833L3.22925 7"
			// stroke="#00AAA9"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const RightArrow = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4 13L16.17 13L10.58 18.59L12 20L20 12L12 4L10.59 5.41L16.17 11L4 11L4 13Z"
			fill="#0866FF"
		/>
	</svg>
);

export const LinkSvg = ({ className }: { className: string }) => (
	<svg className={className} xmlns="http://www.w3.org/2000/svg">
		<path
			// fill="#00AAA9"
			d="M11 10h1v3c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h3v1H1v10h10v-3zM6 2l2.25 2.25L5 7.5 6.5 9l3.25-3.25L12 8V2H6z"
		></path>
	</svg>
);

export const HamburgerSvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3 12H15M3 6H21M3 18H21"
			stroke="#0866FF"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const CloseSvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M18.0237 6L6.02368 18M6.02368 6L18.0237 18"
			stroke="#0866FF"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const SafetySvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="52"
		height="52"
		viewBox="0 0 52 52"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M29.25 17.875C29.25 17.444 29.0788 17.0307 28.774 16.726C28.4693 16.4212 28.056 16.25 27.625 16.25H24.375C23.944 16.25 23.5307 16.4212 23.226 16.726C22.9212 17.0307 22.75 17.444 22.75 17.875V21.125H29.25V17.875ZM30.875 24.375H21.125C20.694 24.375 20.2807 24.5462 19.976 24.851C19.6712 25.1557 19.5 25.569 19.5 26V32.5C19.5 32.931 19.6712 33.3443 19.976 33.649C20.2807 33.9538 20.694 34.125 21.125 34.125H30.875C31.306 34.125 31.7193 33.9538 32.024 33.649C32.3288 33.3443 32.5 32.931 32.5 32.5V26C32.5 25.569 32.3288 25.1557 32.024 24.851C31.7193 24.5462 31.306 24.375 30.875 24.375Z"
			// fill="#0866FF"
		/>
		<path
			d="M40.6251 3.25H11.3751C10.0822 3.25 8.84221 3.76361 7.92797 4.67785C7.01373 5.59209 6.50011 6.83207 6.50011 8.125V36.2213C6.49139 37.8841 6.99311 39.5097 7.93754 40.8784C8.88197 42.2471 10.2236 43.293 11.7814 43.875L24.3751 48.4575C25.456 48.8526 26.6418 48.8526 27.7226 48.4575L40.2189 43.875C41.7766 43.293 43.1183 42.2471 44.0627 40.8784C45.0071 39.5097 45.5088 37.8841 45.5001 36.2213V8.125C45.5001 6.83207 44.9865 5.59209 44.0723 4.67785C43.158 3.76361 41.918 3.25 40.6251 3.25ZM35.7501 32.6462C35.7501 33.9392 35.2365 35.1792 34.3223 36.0934C33.408 37.0076 32.168 37.5213 30.8751 37.5213H21.1251C19.8322 37.5213 18.5922 37.0076 17.678 36.0934C16.7637 35.1792 16.2501 33.9392 16.2501 32.6462V26C16.2563 24.997 16.5717 24.0203 17.1533 23.2031C17.7349 22.386 18.5544 21.7681 19.5001 21.4338V17.875C19.5001 16.5821 20.0137 15.3421 20.928 14.4279C21.8422 13.5136 23.0822 13 24.3751 13H27.6251C28.918 13 30.158 13.5136 31.0723 14.4279C31.9865 15.3421 32.5001 16.5821 32.5001 17.875V21.4662C33.4406 21.7987 34.2565 22.4116 34.8377 23.2223C35.4188 24.0331 35.7373 25.0026 35.7501 26V32.6462Z"
			// fill="#0866FF"
		/>
	</svg>
);

export const TrustSvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="52"
		height="52"
		viewBox="0 0 52 52"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M43.0861 36.8626C43.0861 37.635 42.7803 38.3768 42.2297 38.935C41.7987 39.3682 41.2421 39.6545 40.6391 39.7532C41.3961 40.2885 41.8856 41.1603 41.8856 42.1544C41.8856 42.9268 41.5873 43.6609 41.0367 44.2268C40.4708 44.785 39.7291 45.0832 38.9567 45.0832H38.345C39.0714 45.6185 39.5379 46.475 39.5379 47.4462C39.5379 48.2185 39.2397 48.9526 38.6891 49.5185C38.1156 50.0691 37.3814 50.375 36.6091 50.375H21.6438C18.822 50.375 16.5279 48.0809 16.5279 45.2591V36.1821C16.5279 35.165 16.8185 34.1709 17.3691 33.3068L22.8444 24.6885C23.4638 23.7097 23.7314 22.5397 23.5861 21.385L23.2344 18.6015C23.1656 18.0891 23.3109 17.5844 23.632 17.1868C23.9608 16.7815 24.4197 16.5368 24.932 16.4832C26.645 16.3379 28.2967 16.9497 29.4744 18.1885C30.0572 18.7963 30.4942 19.5286 30.7526 20.3301C31.0109 21.1316 31.0837 21.9813 30.9656 22.815L30.2697 27.7626C30.2532 27.8722 30.2607 27.9841 30.2916 28.0905C30.3226 28.1969 30.3763 28.2953 30.449 28.3789C30.5217 28.4625 30.6117 28.5294 30.7128 28.5748C30.8138 28.6202 30.9236 28.6432 31.0344 28.6421H39.9967C41.6332 28.6421 42.9867 29.8503 43.0785 31.395C43.132 32.2362 42.8261 33.0391 42.2297 33.6509C41.9926 33.8879 41.7173 34.0791 41.4191 34.2244C42.4056 34.6985 43.0861 35.7003 43.0861 36.8626ZM16.5126 20.2074C16.3383 20.3342 16.1318 20.4094 15.9168 20.4243C15.7017 20.4391 15.4868 20.3931 15.2967 20.2915L12.7426 18.9379C12.6581 18.8964 12.5653 18.8748 12.4711 18.8748C12.377 18.8748 12.2841 18.8964 12.1997 18.9379L9.63791 20.2915C9.46967 20.3832 9.28614 20.4291 9.10261 20.4291C8.86555 20.4291 8.63614 20.3526 8.42967 20.2074C8.07026 19.9474 7.89438 19.5191 7.97085 19.0756L8.45261 16.2079C8.49085 16.0168 8.42967 15.8256 8.29967 15.6956L6.21967 13.6691C5.8985 13.3479 5.79144 12.8968 5.93673 12.4685C6.07438 12.0556 6.42614 11.7574 6.86202 11.6962L9.72203 11.2679C9.9132 11.245 10.0738 11.1303 10.1579 10.9544L11.435 8.34677C11.6338 7.94912 12.0238 7.70441 12.4673 7.70441C12.9108 7.70441 13.3085 7.94912 13.5073 8.34677L14.7844 10.9544C14.8685 11.1303 15.0291 11.245 15.2126 11.2679L18.0803 11.6962C18.5161 11.7574 18.8679 12.0556 19.0132 12.4762C19.1508 12.8968 19.0361 13.3556 18.715 13.6691L16.6503 15.6956C16.5356 15.8026 16.4744 15.9556 16.4744 16.1162C16.4744 16.1468 16.4744 16.185 16.482 16.2156L16.9714 19.0756C17.0479 19.5115 16.872 19.9474 16.5126 20.2074ZM19.7014 7.58971C19.3803 7.27618 19.2732 6.81735 19.4185 6.39676C19.5561 5.97618 19.9079 5.67794 20.3438 5.61676L23.2038 5.19618C23.395 5.16559 23.5556 5.05088 23.6397 4.88265L24.9167 2.26735C25.0126 2.07447 25.1603 1.91216 25.3434 1.7987C25.5264 1.68524 25.7375 1.62512 25.9529 1.62512C26.1683 1.62512 26.3794 1.68524 26.5624 1.7987C26.7455 1.91216 26.8933 2.07447 26.9891 2.26735L28.2661 4.875C28.3503 5.05088 28.5108 5.16559 28.6944 5.18853L31.562 5.61676C31.9979 5.67794 32.3497 5.97618 32.4873 6.39676C32.6326 6.81735 32.5179 7.27618 32.1967 7.58971L30.132 9.61618C30.0173 9.72324 29.9561 9.87618 29.9561 10.0444C29.9561 10.075 29.9561 10.1132 29.9638 10.1438L30.4532 12.9962C30.5297 13.4397 30.3538 13.8679 29.9944 14.1279C29.8201 14.2548 29.6136 14.33 29.3985 14.3448C29.1835 14.3597 28.9686 14.3137 28.7785 14.2121L26.2244 12.8585C26.1398 12.8164 26.0464 12.7951 25.952 12.7964C25.8575 12.7977 25.7648 12.8217 25.6814 12.8662L23.1197 14.2121C22.9514 14.3038 22.7679 14.3497 22.5844 14.3497C22.3473 14.3497 22.1179 14.2809 21.9114 14.1356C21.552 13.8756 21.3761 13.4397 21.4526 12.9962L21.9344 10.1362C21.9536 10.0436 21.9497 9.94773 21.923 9.85703C21.8963 9.76633 21.8477 9.6836 21.7814 9.61618L19.7014 7.58971ZM43.7056 15.6956C43.5985 15.8026 43.5373 15.9556 43.5373 16.1162C43.5373 16.1468 43.5373 16.185 43.545 16.2156L44.0344 19.0756C44.1109 19.5115 43.935 19.9474 43.5756 20.2074C43.4013 20.3342 43.1948 20.4094 42.9797 20.4243C42.7647 20.4391 42.5498 20.3931 42.3597 20.2915L39.8056 18.9379C39.7211 18.8964 39.6282 18.8748 39.5341 18.8748C39.44 18.8748 39.3471 18.8964 39.2626 18.9379L36.7009 20.2915C36.5125 20.3943 36.2986 20.4411 36.0844 20.4262C35.8703 20.4113 35.6649 20.3353 35.4926 20.2074C35.1332 19.9474 34.9573 19.5191 35.0338 19.0756L35.5156 16.2079C35.5347 16.1159 35.5301 16.0205 35.5019 15.9309C35.4738 15.8412 35.4232 15.7602 35.355 15.6956L33.2826 13.6691C32.9614 13.3479 32.8544 12.8968 32.992 12.4685C33.0594 12.2666 33.1816 12.0874 33.3451 11.951C33.5085 11.8146 33.7066 11.7264 33.9173 11.6962L36.7773 11.2679C36.8714 11.2595 36.9615 11.2259 37.0381 11.1708C37.1148 11.1156 37.1753 11.0409 37.2132 10.9544L38.4979 8.34677C38.6891 7.94912 39.0867 7.70441 39.5226 7.70441H39.5303C39.9738 7.70441 40.3714 7.94912 40.5626 8.34677L41.8473 10.9544C41.9314 11.1303 42.0844 11.245 42.2679 11.2679L45.1432 11.6962C45.5714 11.7574 45.9309 12.0556 46.0685 12.4762C46.2061 12.8968 46.0991 13.3556 45.7779 13.6691L43.7056 15.6956Z"
			// fill="#949596"
		/>
	</svg>
);

export const ProbitySvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="52"
		height="52"
		viewBox="0 0 52 52"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M26.0506 0C24.9001 0 23.9755 0.92625 23.9755 2.07512V3.653C23.098 4.09013 22.383 4.79375 21.928 5.6615H11.9017C10.9397 5.6615 10.1175 6.16687 9.73072 6.89C9.68684 6.95012 9.62835 6.99725 9.58772 7.06062L4.95972 14.5096L3.69384 16.5441C3.28597 17.2006 3.14947 18.0229 3.32497 18.7752C3.70522 20.4051 4.60384 21.8774 5.87622 23.0035C7.58409 24.5131 9.80059 25.3013 12.1 25.3013C14.3993 25.3013 16.6126 24.5131 18.3205 23.0035C19.5945 21.8774 20.4833 20.4035 20.862 18.785C21.0407 18.031 20.9091 17.2087 20.4996 16.5506L19.2305 14.5096L16.4062 9.9645H21.9231C22.3765 10.8355 23.0947 11.5391 23.9738 11.9762V25.7254C24.6612 25.6197 25.3502 25.5483 26.0457 25.5483C26.7412 25.5483 27.4335 25.6197 28.1208 25.7254V11.9779C29 11.5391 29.7166 10.8355 30.1716 9.96613H35.6901L32.8658 14.5113L31.6 16.5457C31.1905 17.2022 31.0556 18.0245 31.2311 18.7769C31.6113 20.4067 32.51 21.879 33.7823 23.0051C35.4902 24.5147 37.7067 25.3029 40.0061 25.3029C42.3055 25.3029 44.5187 24.5147 46.2266 23.0051C47.499 21.879 48.3911 20.4051 48.7713 18.7866C48.9485 18.0326 48.8185 17.2104 48.409 16.5522L47.1431 14.5113L42.5118 7.05575C42.468 6.98425 42.3981 6.92738 42.3461 6.85913C41.9528 6.15063 41.1468 5.66313 40.1978 5.66313H30.1716C29.7182 4.79375 29 4.09013 28.1208 3.65463V2.07512C28.1225 0.92625 27.1995 0 26.0506 0ZM12.1016 10.7283L15.7871 16.6562L16.3835 17.6182H7.81159L8.37709 16.7131C8.39172 16.6952 8.40634 16.6758 8.41772 16.6562L12.1016 10.7283ZM40.0093 10.7283L43.6948 16.6562L44.2912 17.6182H35.7226L36.2848 16.7131C36.3011 16.6952 36.3141 16.6758 36.3255 16.6562L40.0093 10.7283ZM26.0506 28.197C19.7537 28.197 14.6496 33.3011 14.6496 39.598C14.6496 45.8949 19.7537 50.999 26.0506 50.999C32.3475 50.999 37.4516 45.8949 37.4516 39.598C37.4516 33.3011 32.3475 28.197 26.0506 28.197ZM30.1602 35.9694C30.6997 35.9222 31.2473 36.14 31.6081 36.5853C32.185 37.2986 32.0745 38.363 31.3611 38.9399L25.347 43.8116C24.6336 44.3885 23.5676 44.2747 22.9891 43.5614L22.9858 43.5581L22.9777 43.5484L22.9745 43.5419L20.433 40.4024C19.8545 39.689 19.965 38.6214 20.68 38.0445C21.3933 37.4676 22.4593 37.5781 23.0378 38.2915L24.5393 40.1489L29.2551 36.3334C29.52 36.1189 29.8368 35.997 30.1602 35.9694Z"
			// fill="#949596"
		/>
	</svg>
);

export const ValiditySvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="52"
		height="52"
		viewBox="0 0 52 52"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M25.9488 2.16666C23.5168 2.17424 22.9675 4.32682 20.7228 5.26391C18.4782 6.20099 16.5553 5.07649 14.8403 6.80224C13.1254 8.52799 14.264 10.4466 13.3399 12.6967C12.4158 14.9467 10.26 15.5122 10.2676 17.9443C10.2752 20.3764 12.4299 20.9322 13.367 23.1768C14.3041 25.4215 13.1807 27.3379 14.9053 29.0528C16.63 30.7667 18.5518 29.6292 20.8019 30.5532C23.0358 31.4708 23.6121 33.5996 25.9987 33.6234C28.3853 33.6007 28.9616 31.4708 31.1954 30.5532C33.4455 29.6292 35.3684 30.7677 37.092 29.0528C38.8156 27.3379 37.6933 25.4215 38.6304 23.1768C39.5674 20.9322 41.7222 20.3764 41.7298 17.9443C41.7384 15.5122 39.5826 14.9467 38.6574 12.6967C37.7323 10.4466 38.8719 8.52691 37.157 6.80224C35.4421 5.07757 33.5203 6.20207 31.2745 5.26391C29.0288 4.32574 28.4828 2.17424 26.0507 2.16666C26.0333 2.16666 25.9673 2.16666 25.9488 2.16666ZM25.9889 8.14991C25.9922 8.14991 25.9954 8.14991 25.9998 8.14991C31.3807 8.14991 35.7433 12.5125 35.7433 17.8934C35.7433 23.2743 31.3807 27.638 25.9998 27.638C20.6188 27.638 16.2563 23.2754 16.2563 17.8945C16.2563 12.5168 20.6123 8.15641 25.9889 8.14991ZM25.9998 9.77491C21.5148 9.77491 17.8791 13.4084 17.8791 17.8934C17.8791 22.3784 21.5137 26.0141 25.9976 26.0141C25.9987 26.0141 25.9987 26.0141 25.9987 26.0141C30.4837 26.0141 34.1204 22.3795 34.1204 17.8956C34.1204 13.4106 30.4848 9.77491 25.9998 9.77491ZM25.9705 12.9848C25.9792 12.9848 25.9878 12.9848 25.9954 12.9848C26.2879 12.9827 26.5523 13.1571 26.666 13.4268L27.654 15.8004L30.2074 16.0073C30.605 16.0398 30.9018 16.3887 30.8694 16.7862C30.8542 16.9769 30.7643 17.1524 30.6202 17.277L28.6669 18.9442L29.2617 21.4413C29.3538 21.8302 29.1133 22.2192 28.7243 22.3112C28.538 22.3557 28.343 22.3242 28.1805 22.2246L25.9911 20.8856L23.7952 22.2202C23.4539 22.4261 23.0087 22.3167 22.8018 21.9743C22.7043 21.8118 22.6728 21.6168 22.7173 21.4327L23.3228 18.9312L21.3739 17.2575C21.0717 16.9964 21.0392 16.5392 21.3003 16.2381C21.4238 16.0951 21.5993 16.0062 21.7888 15.99L24.3423 15.795L25.3324 13.4247C25.4418 13.169 25.6899 12.9967 25.9705 12.9848ZM18.1326 31.7557V33.1186V33.6137V35.2831V36.0425V38.207V40.3715V40.6467V42.8133V43.5099V44.9778V45.6744V47.8389C18.1326 48.5431 18.5378 49.2386 19.152 49.5842C19.7663 49.9297 20.5658 49.9167 21.1681 49.5506L25.4819 46.9246C25.7993 46.7296 26.1991 46.7296 26.5165 46.9246L30.8282 49.5506C31.4316 49.9167 32.23 49.9297 32.8443 49.5842C33.4585 49.2386 33.8637 48.5431 33.8637 47.8389V45.6733V44.9767V43.5088V42.8133V40.3715V36.0425V35.2831V33.6137V33.1175V31.7547C33.0826 31.7839 32.4315 31.8121 31.8216 32.0612C31.0698 32.37 30.5465 32.916 29.7438 33.6375C28.941 34.359 27.6898 35.2332 26.0117 35.2495C26.0008 35.2495 25.99 35.2495 25.9803 35.2495C24.3033 35.2322 23.0488 34.359 22.2482 33.6375C21.4476 32.916 20.9308 32.37 20.179 32.0612C19.5713 31.811 18.9169 31.785 18.1326 31.7557Z"
			// fill="#949596"
		/>
	</svg>
);

export const ExportSvg = ({ className }: { className: string }) => (
	<svg
		className={className}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.08073 10.291L8.08073 2.26367"
			stroke="#0E2354"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.0254 8.33887L8.08139 10.2909L6.13739 8.33887"
			stroke="#0E2354"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.5061 5H12.2121C13.7521 5 15 6.2121 15 7.70867L15 11.2987C15 12.7908 13.7551 14 12.2189 14L3.78865 14C2.24865 14 1 12.7872 1 11.2913L1 7.70059C1 6.20916 2.24562 5 3.78108 5H4.49395"
			stroke="#0E2354"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const SearchSvg = ({ color = "#0866FF" }: { color?: string }) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.58268 17.5003C13.9549 17.5003 17.4993 13.9559 17.4993 9.58366C17.4993 5.2114 13.9549 1.66699 9.58268 1.66699C5.21043 1.66699 1.66602 5.2114 1.66602 9.58366C1.66602 13.9559 5.21043 17.5003 9.58268 17.5003Z"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18.3327 18.3337L16.666 16.667"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AddSvg = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.00065 3.33301V12.6663M3.33398 7.99967H12.6673"
			stroke="#F5F6F7"
			strokeWidth="1.33333"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TotalSvg = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="32" height="32" rx="16" fill="#E6F0FF" />
		<g clipPath="url(#clip0_800_20875)">
			<path
				d="M16.0008 4.2998C9.50078 4.2998 4.30078 9.4998 4.30078 15.9998C4.30078 22.4998 9.50078 27.7998 16.0008 27.7998C22.5008 27.7998 27.8008 22.4998 27.8008 15.9998C27.8008 9.4998 22.5008 4.2998 16.0008 4.2998ZM16.0008 26.2998C10.3008 26.2998 5.80078 21.6998 5.80078 15.9998C5.80078 10.2998 10.3008 5.7998 16.0008 5.7998C21.7008 5.7998 26.3008 10.3998 26.3008 16.0998C26.3008 21.7998 21.7008 26.2998 16.0008 26.2998Z"
				fill="#0866FF"
			/>
			<path
				d="M20.0008 10.2001L9.30078 13.8001C8.70078 14.0001 8.40078 14.5001 8.30078 15.1001C8.30078 15.7001 8.70078 16.2001 9.20078 16.4001L13.9008 18.0001L15.6008 22.7001C15.8008 23.3001 16.3008 23.6001 16.9008 23.6001C17.5008 23.6001 18.0008 23.2001 18.2008 22.6001L21.8008 12.0001C22.0008 11.5001 21.8008 11.0001 21.5008 10.6001C21.1008 10.2001 20.5008 10.1001 20.0008 10.2001ZM16.9008 21.9001L15.3008 17.5001C15.2008 17.1001 14.9008 16.8001 14.5008 16.7001L10.1008 15.1001L20.3008 11.7001L16.9008 21.9001Z"
				fill="#0866FF"
			/>
		</g>
		<defs>
			<clipPath id="clip0_800_20875">
				<rect width="24" height="24" fill="white" transform="translate(4 4)" />
			</clipPath>
		</defs>
	</svg>
);

export const AddedSvg = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="32"
			y="32"
			width="32"
			height="32"
			rx="16"
			transform="rotate(180 32 32)"
			fill="#FFF6E6"
		/>
		<g clipPath="url(#clip0_800_20907)">
			<path
				d="M17 11H15V15H11V17H15V21H17V17H21V15H17V11ZM16 6C10.475 6 6 10.475 6 16C6 21.525 10.475 26 16 26C21.525 26 26 21.525 26 16C26 10.475 21.525 6 16 6ZM16 24C11.59 24 8 20.41 8 16C8 11.59 11.59 8 16 8C20.41 8 24 11.59 24 16C24 20.41 20.41 24 16 24Z"
				fill="#FFA108"
			/>
		</g>
		<defs>
			<clipPath id="clip0_800_20907">
				<rect width="24" height="24" fill="white" transform="translate(4 4)" />
			</clipPath>
		</defs>
	</svg>
);

export const ArrowSvg = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.93945 13.2797L10.2861 8.93306C10.7995 8.41973 10.7995 7.57973 10.2861 7.06639L5.93945 2.71973"
			stroke="black"
			strokeOpacity="0.45"
			strokeWidth="1.5"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
